import Chip from "@mui/material/Chip";

const LinqRequestStatus = {
    PENDING: 1,
    ACCEPTED: 2,
    REJECT: 3,
};

export const LinqRequestStatusChip = ({ status }) => {
    let color = null;
    let contrastColor = null;
    let label = null;
    switch (status) {
        case LinqRequestStatus.ACCEPTED:
            color = "#c9f98d";
            contrastColor = "#125511";
            label = "Interested";
            break;
        case LinqRequestStatus.REJECT:
            color = "#f8e2e2";
            contrastColor = "#9d1515";
            label = "Not Interested";
            break;
        case LinqRequestStatus.PENDING:
            color = "#ccf6ff";
            contrastColor = "#015365";
            label = "Pending";
            break;
        default:
            color = "#ccf6ff";
            contrastColor = "#015365";
            label = "DEFAULT";
    }

    return (
        <Chip
            label={label}
            sx={{
                background: color,
                color: contrastColor,
            }}
        />
    );
};
